import { createContext } from "react";
import { UserInfo } from "./../models/UserInfo";

export const userDataContext = createContext<UserInfo | null>(null);

export const UserDataProvider = userDataContext.Provider;
export const UserDataConsumer = userDataContext.Consumer;
